import { Check, Copy } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../../ui/primitives.js";

/** A command to run on the server, shown in full with a copy button that confirms in place. */
export function CommandBlock({ label, command }: { label: string; command: string }) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    await navigator.clipboard.writeText(command);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };
  return (
    <div className="flex flex-col gap-2 rounded-lg border border-line bg-surface-2 p-3 sm:flex-row sm:items-start">
      <code
        aria-label={label}
        className="min-w-0 flex-1 whitespace-pre-wrap break-all font-mono text-xs leading-relaxed"
      >
        {command}
      </code>
      <Button
        variant="secondary"
        className="shrink-0 self-start"
        onClick={() => void copy()}
        icon={
          copied ? (
            <Check className="size-4 text-ok" aria-hidden />
          ) : (
            <Copy className="size-4" aria-hidden />
          )
        }
      >
        {copied ? t("autopilot.copied") : t("autopilot.copy")}
      </Button>
    </div>
  );
}
